import { defineStore } from 'pinia'

export const useSearchOptionsStore = defineStore('SearchOptions', {
    state: () => ({
        options: [],
        activeFilters: [],
    }),
    getters: {
        getOptions: (state) => {
            return () => state.options;
        },
        getActiveFilters: (state) => {
            return () => state.activeFilters;
        },
    },
    actions: {
        setOptions(options) {
            this.options = options;
        },
        setActiveFilters(activeFilters) {
            this.activeFilters = activeFilters;
        },
    },
})
